import { render, staticRenderFns } from "./CommonBgColorChunk.vue?vue&type=template&id=045506b3&scoped=true"
import script from "./CommonBgColorChunk.vue?vue&type=script&lang=js"
export * from "./CommonBgColorChunk.vue?vue&type=script&lang=js"
import style0 from "./CommonBgColorChunk.vue?vue&type=style&index=0&id=045506b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045506b3",
  null
  
)

export default component.exports